import { StorageOption } from 'owa-storage-option';
import { getAccountInformation } from 'owa-storage-option';
var storageSubcategory = {
    key: 'storage',
    titleStringKey: 'optionSubcategory_mailboxCleanup',
    options: [StorageOption],
    onSelected: function () {
        return getAccountInformation();
    },
};
export default storageSubcategory;
//# sourceMappingURL=storageSubCategory.js.map